import React from "react";
import { StyleSheet, View } from "react-native";
import Colors from "@microdoing/shared/constants/Colors";
import CheckIcon from "../../scenes/CurrentTrackScreen/CheckIcon";
import { MainText } from "./MainText";
import { Box } from "./Box/MainBox/MainBox";
import theme from "app/Theme/Theme";
import { PressableOpacity } from "./PressableOpacity";
import { backgroundColor } from "@shopify/restyle";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing.xm,
  },
  checkIcon: {
    justifyContent: "flex-end",
  },
});

interface Props {
  text: string;
  isSelected: boolean;
  onPress(): void;
  emojiText?: string;
}

const CheckRow = ({
  text = "",
  isSelected = false,
  onPress = () => {},
  emojiText,
}: Props) => {
  return (
    <PressableOpacity style={styles.container} onPress={onPress}>
      <Box
        style={{
          backgroundColor: isSelected
            ? theme.colors["brand.50"]
            : theme.colors["neutral.white"],
          borderRadius: 8,
        }}
      >
        <Box
          width="100%"
          flex={1}
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          paddingVertical="m"
          paddingHorizontal="xs"
        >
          {emojiText && (
            <MainText
              variant="l4-medium"
              marginRight="s"
              opacity={!isSelected ? 0.5 : 1}
            >
              {emojiText}
            </MainText>
          )}
          <Box
            flex={1}
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <MainText
              color={isSelected ? "brand.500" : "neutral.900"}
              variant="l4-medium"
              opacity={!isSelected ? 0.5 : 1}
            >
              {text}
            </MainText>
            {isSelected && (
              <View style={styles.checkIcon}>
                <CheckIcon color={Colors.blue} height={10}></CheckIcon>
              </View>
            )}
          </Box>
        </Box>
      </Box>
    </PressableOpacity>
  );
};

export { CheckRow };
